import { JtechAxios } from 'src/plugins/axios'

export const DatatableRepository = {
  fetchDatatable: async function (interfaceName) {
    try {
      const dataResponse = await JtechAxios.request().get('fw-form/resolveForm?nmInterface=' + interfaceName)
      return dataResponse.data.datatables[0]
    } catch (ex) {
    }
  }
}
